 require('./currency');require('../i18n');
riot.tag2('basket', '<table if="{basket.items.length}" class="table table-striped table-condensed table-responsive"> <thead> <tr> <th if="{options.editable}"></th> <th riot-tag="i18n" class="col-xs-6">Description</th> <th riot-tag="i18n" class="col-xs-2">Qty</th> <th riot-tag="i18n" class="hidden-xs">Item Price</th> <th riot-tag="i18n" class="hidden-xs">Line Total</th> <th if="{options.showvat}" riot-tag="i18n" class="hidden-xs">Line Tax</th> <th riot-tag="i18n" class="visible-xs">Item Price</th> </tr> </thead> <tbody> <tr each="{product in basket.items}"> <td if="{options.editable}"> <button onclick="{remove}" if="{product.id}" class="btn btn-sm btn-warning">✕</button> </td> <td if="{!product.page || !product.page.path}" class="col-xs-5">{productName(product)}</td> <td if="{product.page &amp;&amp; product.page.path}" class="col-xs-5"><a href="{product.page.path}">{productName(product)} <small>(more info)</small></a></td> <td if="{options.editable &amp;&amp; product.id &amp;&amp; product.type!=\'asset\'}" class="col-xs-2"> <input value="{product.qty}" onchange="{updateQty}" class="form-control"> </td> <td if="{(!options.editable &amp;&amp; product.type!=\'asset\') || !product.id}" class="col-xs-2">{product.qty}</td> <td if="{product.type==\'asset\'}" class="col-xs-2"></td> <td if="{options.showvat}" class="hidden-xs"> <currency value="{product.price}" code="{parent.opts.currency}"> </currency> </td> <td if="{options.showvat}" class="hidden-xs"> <currency value="{product.total}" code="{parent.opts.currency}"> </currency> </td> <td if="{options.showvat}" class="hidden-xs"> <currency value="{product.totaltax}" code="{parent.opts.currency}"> </currency> </td> <td if="{!options.showvat}" class="hidden-xs"> <currency value="{product.price + product.tax}" code="{parent.opts.currency}"> </currency> </td> <td if="{!options.showvat}" class="hidden-xs"> <currency value="{product.total + product.totaltax}" code="{parent.opts.currency}"> </currency> </td> <td class="visible-xs"> <currency value="{product.price + product.tax}" code="{parent.opts.currency}"> </currency> </td> </tr> </tbody> <tfoot> <tr if="{options.showvat}" class="hidden-xs"> <td if="{options.editable}"></td> <td> </td> <td></td> <td><strong riot-tag="i18n">Subtotals</strong></td> <td><strong> <currency value="{basket.subtotal}" code="{opts.currency}"> </currency></strong></td> <td><strong> <currency value="{basket.tax}" code="{opts.currency}"> </currency></strong></td> </tr> <tr class="info"> <td if="{options.editable}"></td> <td class="hidden-xs"></td> <td></td> <td if="{options.showvat}" class="hidden-xs"></td> <td><strong riot-tag="i18n">Total</strong></td> <td><strong> <currency value="{basket.total}" code="{opts.currency}"> </currency></strong></td> </tr> </tfoot> </table> <p if="{basket.items.length==0}" riot-tag="i18n">You have no items in your basket</p> <div if="{basket.errors &amp;&amp; basket.errors.length&gt;0}"> <div each="{basket.errors}" class="alert alert-danger">{message}</div> </div> <div if="{basket.warnings &amp;&amp; basket.warnings.length&gt;0}"> <div each="{basket.warnings}" class="alert alert-warning">{message}</div> </div>', '', '', function(opts) {
var resource;

resource = require('../../utils/apiResource.coffee');

this.options = {};

this.productName = (function(_this) {
  return function(product) {
    if ((product != null ? product[_this.nameField] : void 0) != null) {
      return product[_this.nameField];
    } else {
      return product.name;
    }
  };
})(this);

this.on('mount', (function(_this) {
  return function() {
    _this.basketApi = new resource(opts.src || '/duocms/api/basket');
    _this.nameField = opts.language === 'de' ? 'name_de' : 'name';
    _this.root.trigger = _this.trigger;
    return _this.updateBasket();
  };
})(this));

this.on('update', (function(_this) {
  return function() {
    _this.options.editable = opts.editable != null ? opts.editable : true;
    return _this.options.showvat = opts.showvat != null ? opts.showvat : true;
  };
})(this));

this.on('updateBasket', function() {
  return this.updateBasket();
});

this.on('comfirmBasket', function(postage_id, country_code) {
  return this.updateBasket(postage_id, country_code);
});

this.hasItems = (function(_this) {
  return function() {
    var ref, ref1;
    return (ref = _this.basket) != null ? (ref1 = ref.items) != null ? ref1.length : void 0 : void 0;
  };
})(this);

this.updateBasket = (function(_this) {
  return function(postage_id, country_code) {
    if (postage_id == null) {
      postage_id = null;
    }
    if (country_code == null) {
      country_code = null;
    }
    return _this.basketApi.get({
      postage_id: postage_id,
      country_code: country_code,
      currency: opts.currency
    }, function(basket) {
      _this.basket = basket;
      return _this.update();
    });
  };
})(this);

this.remove = (function(_this) {
  return function(e) {
    return _this.basketApi.remove({
      id: e.item.product.id
    }, function(basket) {
      _this.basket = basket;
      return _this.update();
    });
  };
})(this);

this.updateQty = (function(_this) {
  return function(e) {
    return _this.basketApi.save({
      id: e.item.product.id,
      qty: e.target.value
    }, function(basket) {
      _this.basket = basket;
      return _this.update();
    });
  };
})(this);
});